export function compareStringValues<T extends { [K in keyof T]: number | string }>(
    key: keyof T
): (a: T, b: T) => number {
    return (a: T, b: T) => {
        return a[key].toString().localeCompare(b[key].toString());
    };
}
